import React from 'react';
import TreeMenuNew, {DISPLAY_TYPE_TREE} from "../../../componentsReusable/TreeMenuNew/TreeMenuNew";
import {ListGroupItem} from "reactstrap";
import AdjustTable from "../Adjust/AdjustTable";

const LinkedAdjusts = props => {
  const getMappedItems = () => {
    return props.adjusts.map(adjust => ({
      key: 'mainGroup' + adjust.ItemMpId,
      id: adjust.ItemMpId,
      label: adjust.ItemMpText,
      component: <ListGroupItem>
        <AdjustTable itemMpId={adjust.ItemMpId} />
      </ListGroupItem>,
    }))
  }

  return (
    <div>
      <TreeMenuNew
        isMulti
        displayType={DISPLAY_TYPE_TREE}
        actives={props.params}
        items={getMappedItems()}
      />
    </div>
  );
};

LinkedAdjusts.propTypes = {

};

export default LinkedAdjusts;